const colors = {
  active: '#7bfac3',
  inactive: '#979797',
  new: '#FFB538'
};

export default colors;